module.exports = __webpack_public_path__ + "media/images/v3/rating-3bdf19a73f331090f9fdd7b2bc339082.png";